/**
 * 巡检管理（inspectionManagement）模块英文映射 · 第 3 组（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/inspectionManagement/ 下
 * - ProblemManagementWaterWorks/（ProblemReporting、index、rejectAndStopModal）
 * - deviceManagement/（dataList、index、mapList、modules/deviceModal、modules/historyModal）
 * - home.vue
 * - inspectionPersonnel/（index、modules/modal）
 * - inspectionPlan/（inspectionPlanIndex 及 modules/ 下 inspectionPlanDetailModal、
 *   inspectionPlanModal、inspectionPlanTaskModal、taskAllocationModal）
 * - inspectionPlanOutsourcing/（inspectionPlanIndex 及 modules/ 同名五个文件）
 * - inspectionPlanRevenue/（inspectionPlanIndex、modules/inspectionPlanDetailModal）
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js）──
  '确定': 'OK',
  '关闭': 'Close',
  '提示': 'Notice',
  '查询': 'Query',
  '重置': 'Reset',
  '编辑': 'Edit',
  '删除': 'Delete',
  '新增': 'Add',
  '详情': 'Details',
  '更多': 'More',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '已选择 {count} 项': '{count} items selected',
  '确定删除吗?': 'Are you sure you want to delete?',
  '是': 'Yes',
  '否': 'No',
  '操作': 'Action',
  '创建时间': 'Created At',
  '创建人': 'Created By',
  '更新时间': 'Updated At',
  '备注': 'Remark',
  '状态': 'Status',
  '展开': 'Expand',
  '收起': 'Collapse',
  '上传': 'Upload',
  '下载': 'Download',
  '确认': 'Confirm',
  // ── 设备管理 ──
  '设备管理页面': 'Device Management Page',
  '数据列表': 'Data List',
  '地图展示': 'Map View',
  '设备编号': 'Device No.',
  '设备名称': 'Device Name',
  '设备类型': 'Device Type',
  '设备描述': 'Device Description',
  '设备经度': 'Device Longitude',
  '设备纬度': 'Device Latitude',
  '请选择设备类型': 'Please select device type',
  '请输入设备名称': 'Please enter device name',
  '请输入设备编号': 'Please enter device No.',
  '请输入设备描述': 'Enter device description',
  '请输入设备经度': 'Enter device longitude',
  '请输入设备纬度': 'Enter device latitude',
  '图片附件上传': 'Image Attachments',
  '搜索地址': 'Search address',
  '是否正常': 'Normal or Not',
  '请选择是否正常': 'Please select whether it is normal',
  '正常': 'Normal',
  '异常': 'Abnormal',
  '结果描述': 'Result Description',
  '请输入备注信息': 'Please enter remark',
  '经度：': 'Longitude: ',
  '纬度：': 'Latitude: ',
  '是否使用当前位置信息?': 'Use current location?',
  '历史数据': 'Historical Data',
  '历史记录': 'History',
  '巡检历史记录': 'Inspection History',
  '巡检人员': 'Inspection Personnel',
  '巡检时间': 'Inspection Time',
  '是否存在问题': 'Problem or Not',
  '运行状态': 'Running Status',
  '巡检结果': 'Inspection Result',
  '解决前照片或视频': 'Photos/Videos Before Resolution',
  '解决后照片或视频': 'Photos/Videos After Resolution',
  '无图片': 'No Image',
  '无文件': 'No File',
  '预览': 'Preview',
  // ── 巡检首页 ──
  '业务数量': 'Business Volume',
  '业务数量趋势': 'Business Volume Trend',
  '近一周': 'Last 7 Days',
  '近一月': 'Last Month',
  '近一年': 'Last Year',
  '巡检任务': 'Inspection Task',
  '未分配': 'Unassigned',
  '已分配': 'Assigned',
  '结束': 'Finished',
  '巡检任务本月完成情况': 'Inspection Task Completion This Month',
  '本月已完成': 'Completed This Month',
  '本月未完成': 'Unfinished This Month',
  '本月超时未完成': 'Overdue This Month',
  '本月按时完成率': 'On-time Completion Rate This Month',
  '巡检总数': 'Total Inspections',
  '当日巡检任务数': 'Today\'s Inspection Tasks',
  '这是当日巡检任务数': 'Number of inspection tasks today',
  '未巡检任务数': 'Uninspected Tasks',
  '这是未巡检任务数': 'Number of uninspected tasks',
  '即将过期任务数': 'Expiring Soon Tasks',
  '小于三天的统计': 'Statistics within three days',
  '任务名称': 'Task Name',
  '任务类型': 'Task Type',
  '临时任务': 'Temporary Task',
  '日常任务': 'Routine Task',
  '任务状态': 'Task Status',
  '开始时间': 'Start Time',
  '结束时间': 'End Time',
  '执行人员类型': 'Executor Type',
  '班组': 'Team',
  '成员': 'Member',
  '执行人员(班组/成员)': 'Executor (Team/Member)',
  // ── 巡检人员 ──
  '人员姓名': 'Personnel Name',
  '请输入人员姓名': 'Please enter personnel name',
  '人员电话': 'Personnel Phone',
  '选择人员': 'Select Personnel',
  '请选择人员': 'Please select personnel',
  // ── 问题上报 / 问题管理 ──
  '问题上报': 'Problem Reporting',
  '问题确认': 'Problem Confirmation',
  '问题处理': 'Problem Handling',
  '问题记录': 'Problem Records',
  '问题详情': 'Problem Details',
  '问题等级': 'Problem Level',
  '请选择问题等级': 'Select problem level',
  '问题描述': 'Problem Description',
  '上报人': 'Reporter',
  '上报人电话': 'Reporter Phone',
  '现场坐标': 'On-site Coordinates',
  '检测实体': 'Detected Entity',
  '现场图片或视频': 'On-site Photos or Videos',
  '是否现场已解决': 'Resolved On Site',
  '已解决': 'Resolved',
  '未解决': 'Unresolved',
  '驳回': 'Reject',
  '驳回原因': 'Rejection Reason',
  '请输入驳回原因': 'Please enter rejection reason',
  '搁置': 'On Hold',
  '搁置原因': 'On-hold Reason',
  '请输入搁置原因': 'Please enter on-hold reason',
  '驳回成功！': 'Rejected successfully!',
  '搁置成功！': 'Put on hold successfully!',
  '未确认': 'Unconfirmed',
  '已确认': 'Confirmed',
  '已完成': 'Completed',
  '工单处理中': 'Work Order Processing',
  '时间范围': 'Time Range',
  // ── 巡检计划 ──
  '巡检计划页面': 'Inspection Plan Page',
  '巡检计划信息': 'Inspection Plan Info',
  '路线-设备信息': 'Route - Device Info',
  '计划名称': 'Plan Name',
  '请输入计划名称': 'Please enter plan name',
  '计划类型': 'Plan Type',
  '请选择计划类型': 'Please select plan type',
  '请输入计划类型': 'Please enter plan type',
  '请输入巡检方案名称': 'Please enter inspection plan name',
  '计划类别': 'Plan Category',
  '请选择计划类别': 'Please select plan category',
  '重点区域': 'Key Area',
  '查漏专项': 'Leak Detection Special',
  '来源': 'Source',
  '请选择来源': 'Please select source',
  '请选择状态': 'Select status',
  '水厂': 'Water Plant',
  '外围': 'External',
  '营收': 'Revenue',
  '计划区域': 'Plan Area',
  '请选择区域': 'Please select area',
  '请输入计划区域': 'Please enter plan area',
  '请输入区域名称': 'Please enter area name',
  '请选择区域名称': 'Please select area name',
  '周期': 'Cycle',
  '请输入周期值': 'Please enter cycle value',
  '请选择周期类型': 'Please select cycle type',
  '启用时间': 'Activation Time',
  '请选择启用时间': 'Please select activation time',
  '测点实体': 'Monitoring Point Entity',
  '请选择测点实体': 'Please select monitoring point entity',
  '巡检方式': 'Inspection Method',
  '请选择巡检方式': 'Please select inspection method',
  '步巡': 'Foot Patrol',
  '车巡': 'Vehicle Patrol',
  '其他指标': 'Other Indicators',
  '请输入其他指标': 'Please enter other indicators',
  '巡检要求': 'Inspection Requirements',
  '请输入巡检要求': 'Please enter inspection requirements',
  '选择路线': 'Select Route',
  '请选择路线': 'Please select route',
  '路线详情': 'Route Details',
  '路线名称': 'Route Name',
  '计划周期': 'Plan Cycle',
  '计划状态': 'Plan Status',
  '区域': 'Area',
  '未启用': 'Not Enabled',
  '已启用': 'Enabled',
  '停用': 'Disable',
  '启用': 'Enabled',
  '确定停用吗?': 'Are you sure to disable?',
  '确定启用吗?': 'Are you sure to enable?',
  '停用成功': 'Disabled successfully',
  '启用成功': 'Enabled successfully',
  '是否反馈': 'Feedback or Not',
  '请选择是否反馈': 'Please select whether feedback is required',
  '是否常规': 'Routine or Not',
  '请选择是否常规': 'Please select whether it is routine',
  '是否自动分派': 'Auto Assignment',
  '请选择是否自动分派': 'Please select whether to auto assign',
  '实施人类型': 'Implementer Type',
  '请选择实施人类型': 'Please select implementer type',
  '实施人员': 'Implementer',
  '指定班组': 'Assign Team',
  '直接指定实施人员': 'Assign Implementer Directly',
  '选择实施人': 'Select Implementer',
  '选择班组': 'Select Team',
  '请选择班组': 'Please select team',
  // ── 巡检计划任务/分派弹窗 ──
  '巡检线路': 'Inspection Route',
  '换表': 'Meter Replacement',
  '请选择工单类型': 'Please select work order type',
  '请输入地理信息': 'Please enter geographic info',
  '请输入工单联系人': 'Please enter work order contact',
  '请输入联系电话': 'Please enter contact phone',
  '请输入紧急程度': 'Please enter urgency level',
  '请选择截止时间': 'Please select deadline',
  '请输入事务分类': 'Please enter transaction category',
  '巡检状态': 'Inspection Status',
  '添加成功': 'Added successfully'
}
